(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 7487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/styles.js
var styles = __webpack_require__(6808);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/blog/BlogInstance.tsx






var Container = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
  displayName: "BlogInstance__Container",
  componentId: "sc-kb0g2t-0"
})(["width:100%;border-radius:10px;overflow:hidden;transition:0.3s ease-in-out;cursor:pointer;box-shadow:", ";min-height:500px;display:flex;flex-direction:column;>img{width:100%;height:12.5rem;object-fit:cover;}@media ", "{max-width:350px;:hover{box-shadow:", ";}}"], styles/* shadow600 */.W5, styles/* device.laptopSmall */.Uh.laptopSmall, styles/* shadow600 */.W5);
var TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BlogInstance__TextContainer",
  componentId: "sc-kb0g2t-1"
})(["text-align:left;padding:20px;display:flex;flex-direction:column;flex-grow:1;row-gap:0.5rem;>h3{font-weight:600;color:", ";}>span{font-size:0.9rem;color:", ";text-transform:uppercase;margin-bottom:-0.5rem;}>p{color:", "90;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden;}>a{margin-top:auto;align-self:flex-end;}"], styles/* BLACKGREY */.oz, styles/* DARKGREY */.Sn, styles/* DARKGREY */.Sn);

var BlogInstance = function BlogInstance(_ref) {
  var id = _ref.id,
      image = _ref.image,
      topic = _ref.topic,
      title = _ref.title,
      description = _ref.description,
      url = _ref.url;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: image
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "topic",
        children: topic
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: "title h5",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "description p",
        children: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/".concat(url),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* Button */.zx, {
          className: "small",
          children: "Read More \u2192"
        })
      })]
    })]
  });
};

/* harmony default export */ var blog_BlogInstance = (BlogInstance);
// EXTERNAL MODULE: ./components/general/Layout.tsx + 7 modules
var Layout = __webpack_require__(2002);
;// CONCATENATED MODULE: ./pages/blog/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var BlogsContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  displayName: "blog__BlogsContainer",
  componentId: "sc-ikm198-0"
})(["display:grid;grid-template-columns:1fr;grid-gap:1rem;padding:1rem;min-height:100%;@media ", "{grid-template-columns:repeat(3,1fr);}"], styles/* device.laptopSmall */.Uh.laptopSmall);

var Page = function Page(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogsContainer, {
    className: "sectionPadding",
    children: props.blogs.map(function (blog) {
      return /*#__PURE__*/(0,react.createElement)(blog_BlogInstance, _objectSpread(_objectSpread({}, blog), {}, {
        key: blog._id,
        id: blog._id
      }));
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var blog = (Page);

Page.getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    children: page
  });
};

/***/ }),

/***/ 7801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(7487);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [108,103,2,774,888,179], function() { return __webpack_exec__(7801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);